// extracted by mini-css-extract-plugin
export default {"component":"styles__component--aKtLC","isActive":"styles__isActive--MI8iT","icon":"styles__icon--HaoyT"};